import { TV_DATE_RANGES } from '../../utils/chartLayouts';

/**
 * TradingView bottom date-range bar:
 * 1D | 5D | 1M | 3M | 6M | YTD | 1Y | 5Y | All
 */
export default function TvBottomTimeframes({
  value = '1M',
  onChange,
  ranges = TV_DATE_RANGES,
}) {
  return (
    <footer className="tv-bottom-bar" aria-label="Date range">
      <div className="tv-bottom-ranges">
        {ranges.map((r) => (
          <button
            key={r.id}
            type="button"
            className={`tv-range-btn${value === r.id ? ' active' : ''}`}
            onClick={() => onChange?.(r.id)}
          >
            {r.label}
          </button>
        ))}
      </div>
      <div className="tv-bottom-meta">
        <span className="tv-bottom-tz">Asia/Kolkata</span>
      </div>
    </footer>
  );
}
